import { z } from 'zod';
import { ProbeTierSchema } from './event.js';

export const ProbeProtocolSchema = z.enum(['ble', 'wifi_mqtt', 'lorawan', 'zigbee', 'manual']);
export type ProbeProtocol = z.infer<typeof ProbeProtocolSchema>;

export const ProbeVendorSchema = z.enum([
  'inkbird',
  'ruuvi',
  'xsense',
  'govee',
  'sensorpush',
  'dragino',
  'sonoff',
  'testo',
  'generic',
]);
export type ProbeVendor = z.infer<typeof ProbeVendorSchema>;

export const ProbeSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  business_id: z.string().uuid(),
  storage_unit_id: z.string().uuid().nullable(),
  name: z.string().min(1).max(200),
  vendor: ProbeVendorSchema,
  model: z.string().max(100),
  serial: z.string().max(100).nullable(),
  mac_or_id: z.string().max(100).nullable(),
  protocol: ProbeProtocolSchema,
  tier: ProbeTierSchema,
  calibration_valid_until: z.string().date().nullable(),
  certificate_file_id: z.string().nullable(),
  offset_c: z.number().default(0),
  active: z.boolean().default(true),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  version: z.number().int().nonnegative().default(0),
});
export type Probe = z.infer<typeof ProbeSchema>;
